import axios from "axios";
import authentication from "@/authentication";
export default {
  baseUrl: process.env.VUE_APP_API_ADMIN_SERVICE_BASE,
  async getUsers() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetAdminUsers`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async toggleGroup(userId, groupId, value) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/ToggleGroup/${userId}/${groupId}/${value}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async getUserDetails(uid) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetUserDetails/${uid}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  }
};
